import { Stack } from "@mui/material";
import { CbhIcon, Pill, Text } from "@src/appV2/redesign/system/ui-components";

export function RestrictedBadge(): JSX.Element {
  return (
    <Pill
      label={
        <Stack direction="row" gap={3} alignItems="center">
          <CbhIcon type="diamond-colored" size="medium" />
          <Text semibold variant="body2" color={(theme) => theme.palette.error?.main ?? ""}>
            Restricted
          </Text>
        </Stack>
      }
      sx={{
        backgroundColor: (theme) => theme.palette.background?.tertiary ?? "",
      }}
    />
  );
}
